import { AuthLayout } from "layout";
import { ChangeIpPage } from "pages/user";
import { ForgotPasswordPage, LoginPage, RegisterPage, ResetPasswordPage } from "pages/user/auth";
import { redirect, RouteObject } from "react-router-dom";

export const authUserRouter: RouteObject[] = [
  {
    path: "*",
    loader() {
      const queryParamsURL = Object.fromEntries(new URLSearchParams(window.location.search));

      const ref = queryParamsURL["ref"];

      if (ref) {
        window.localStorage.setItem("ref", ref)
        return redirect("/auth/register");
      } else {
        return redirect("/auth/login");
      }
    },
  },
  {
    path: "auth",
    element: <AuthLayout />,
    children: [
      {
        path: "register",
        element: <RegisterPage />,
      },
      {
        path: "login",
        element: <LoginPage />,
      },
      {
        path: "forgot-password",
        element: <ForgotPasswordPage />,
      },
      {
        path: "reset-password/:token",
        element: <ResetPasswordPage />,
      },

    ],
  },
  {
    path: "change-ip",
    element: <ChangeIpPage />,
  }
];
